import { createFileRoute } from '@tanstack/react-router'
import { AvailabilityPlanning } from 'pages/availabilityPlanning/AvailabilityPlanning'
import { z } from 'zod'

export const availabilityPlanningSearchSchema = z.object({})

export const Route = createFileRoute('/availability-planning/$siteID/$shipID/')(
  {
    component: AvailabilityPlanning,
    staticData: {
      layout: {
        enableScrolling: false,
      },
    },
    validateSearch: availabilityPlanningSearchSchema,
  }
)
